import { BUDGET_MANAGER_COLUMNS } from '@domain/dashboard/budget-manager/button/budget-manager-button.constants';
import { METRICS_TYPES } from '../MetricsTypeConstants';

export const SUM_METRICS = [
    'conversions',
    'impressions',
    'revenue',
    'cost',
    'clicks',
    'ticket_value',
    'quality_score',
    'reach',
    'projected_clicks',
    'projected_revenue',
    'projected_conversions',
    'projected_cost',
    'budget',
];

export const campaignTable = {
    metrics: gettext('Metrics'),
    campaignType: gettext('Campaign Type'),
    metricsPlaceholder: gettext('Metrics'),
    name: gettext('Campaigns'),
    status: gettext('Status'),
    budget: gettext('Daily Budget'),
    searchInput: gettext('Search...'),
    subtitleDashboard: gettext('A deep dive view of your campaigns.'),
    title: gettext('This month prediction by campaign'),
    titleDashboard: gettext('Campaigns and Groups'),
    totalAccount: gettext('Total (Account)'),
    selectTitle: gettext('Select any metric'),
    tag: gettext('Tags'),
    bidStrategyType: gettext('Bid Strategy'),
};

export const STRING_METRICS = ['id', 'name', 'tags', 'status', 'type', 'bid_strategy_type'];

/**
    @todo: Move this constants to segments domain
*/
export const STANDARD = 'standard';
export const CAMPAIGN_TYPE = 'campaign_type';

export const VIEW_TYPE = {
    standard: STANDARD,
    campaignType: CAMPAIGN_TYPE,
};

export const VIEW_TYPE_GROUP = Object.values(VIEW_TYPE)
    .map(slug => ({ id: null, slug }));

export const INITIAL_SELECTED_GROUP = {
    id: null,
    slug: VIEW_TYPE.standard,
};

export const NAME = 'name';
export const STATUS = 'status';
export const BUDGET = 'budget';
export const BID_STRATEGY_TYPE = 'bid_strategy_type';
export const CAMPAIGN = 'campaign';

export const COLUMN_WIDTH = 180;
export const STATUS_COLUMN_WIDTH = 70;

export const getMetricsFormula = (prefix = '') => ({
    [`${prefix}quality_score`]: {
        dividend: `${prefix}quality_score`,
        divider: `${prefix}cost`,
        multiplier: 1,
    },
    [`${prefix}cpm`]: {
        dividend: `${prefix}cost`,
        divider: `${prefix}impressions`,
        multiplier: 1000,
    },
    [`${prefix}ctr`]: {
        dividend: `${prefix}clicks`,
        divider: `${prefix}impressions`,
        multiplier: 1,
    },
    [`${prefix}roas`]: {
        dividend: `${prefix}revenue`,
        divider: `${prefix}cost`,
        multiplier: 1,
    },
    [`${prefix}cpa`]: {
        dividend: `${prefix}cost`,
        divider: `${prefix}conversions`,
        multiplier: 1,
    },
    [`${prefix}cpc`]: {
        dividend: `${prefix}cost`,
        divider: `${prefix}clicks`,
        multiplier: 1,
    },
    [`${prefix}cpv`]: {
        dividend: `${prefix}cost`,
        divider: `${prefix}impressions`,
        multiplier: 1,
    },
    [`${prefix}conv_rate`]: {
        dividend: `${prefix}conversions`,
        divider: `${prefix}clicks`,
        multiplier: 1,
    },
    [`${prefix}ticket_value`]: {
        dividend: `${prefix}revenue`,
        divider: `${prefix}conversions`,
        multiplier: 1,
    },
});

const nameCampaignObject = {
    label: campaignTable.name,
    type: 'string',
    value: NAME,
};

const statusCampaignObject = {
    isVisible: false,
    index: 0,
    label: campaignTable.status,
    type: 'string',
    value: STATUS,
};

const budgetCampaignObject = {
    isVisible: false,
    index: 0,
    label: campaignTable.budget,
    type: METRICS_TYPES.currency,
    value: BUDGET,
};

const bidStrategyTypeObject = {
    isVisible: false,
    index: 0,
    label: campaignTable.bidStrategyType,
    type: METRICS_TYPES.string,
    value: BID_STRATEGY_TYPE,
};

export const CAMPAIGN_TABLE_DEFAULT_COLUMNS = {
    [STATUS]: statusCampaignObject,
    [NAME]: nameCampaignObject,
    [BID_STRATEGY_TYPE]: bidStrategyTypeObject,
    [BUDGET]: budgetCampaignObject,
};

export const CAMPAIGN_TABLE_BUDGET_MANAGER_COLUMNS = {
    [NAME]: nameCampaignObject,
    [BID_STRATEGY_TYPE]: bidStrategyTypeObject,
    budget_manager_status: {
        label: gettext('Budget Manager'),
        value: BUDGET_MANAGER_COLUMNS.budget_manager_status,
        type: METRICS_TYPES.currency,
        status: 'enabled',
    },
    bid_manager_status: {
        label: gettext('Target Manager'),
        value: BUDGET_MANAGER_COLUMNS.bid_manager_status,
        type: METRICS_TYPES.currency,
        status: 'enabled',
    },
    monthly_budget: {
        label: gettext('Monthly Budget'),
        value: BUDGET_MANAGER_COLUMNS.monthly_budget,
        type: METRICS_TYPES.currency,
    },
    daily_budget_cluster: {
        label: gettext('Daily Budget'),
        value: BUDGET_MANAGER_COLUMNS.daily_budget_cluster,
        type: METRICS_TYPES.currency,
    },
    pace_budget: {
        label: gettext('Maximum Daily Budget Adjustment'),
        value: BUDGET_MANAGER_COLUMNS.pace_budget,
        type: METRICS_TYPES.percent,
    },
    minimum_performance_value: {
        label: gettext('Target ROAS/CPA/CPC'),
        value: BUDGET_MANAGER_COLUMNS.minimum_performance_value,
        type: METRICS_TYPES.float,
    },
    performance_window: {
        label: gettext('Performance Window in days'),
        value: BUDGET_MANAGER_COLUMNS.performance_window,
        type: METRICS_TYPES.number,
    },
    minimum_daily_budget_value: {
        label: gettext('Minimum Daily Budget Value'),
        value: BUDGET_MANAGER_COLUMNS.minimum_daily_budget_value,
        type: METRICS_TYPES.float,
    },
    days_between_adjustments_budget: {
        label: gettext('Days between budget adjustments'),
        value: BUDGET_MANAGER_COLUMNS.days_between_adjustments_budget,
        type: METRICS_TYPES.number,
    },
    pace_target: {
        label: gettext('Maximum Daily Target Adjustment'),
        value: BUDGET_MANAGER_COLUMNS.pace_target,
        type: METRICS_TYPES.percent,
    },
    days_between_adjustments_target: {
        label: gettext('Days between target adjustments'),
        value: BUDGET_MANAGER_COLUMNS.days_between_adjustments_target,
        type: METRICS_TYPES.number,
    },
};

export const DEFAULT_COLUMNS = Object.keys(CAMPAIGN_TABLE_DEFAULT_COLUMNS);
